module.exports = __webpack_public_path__ + "static/media/自动录入.1848a384.png";